import { gql } from "graphql-tag"

const critics = gql`
  input ReviewAddInput {
    audio: ScoreAndQuoteInput!
    author: AuthorInput
    editions: [String]
    extra: ScoreAndQuoteInput!
    images: CriticImagesInput
    movie: ScoreAndQuoteInput!
    releaseDate: String
    serviceName: String!
    techSpecs: [[String]]
    total: ScoreAndQuoteInput!
    url: String!
    video: ScoreAndQuoteInput!
  }

  input ReviewUpdateInput {
    audio: ScoreAndQuoteInput
    author: AuthorInput
    editions: [String]
    extra: ScoreAndQuoteInput
    id: ID!
    images: CriticImagesInput
    movie: ScoreAndQuoteInput
    releaseDate: String
    serviceName: String
    techSpecs: [[String]]
    total: ScoreAndQuoteInput
    url: String!
    video: ScoreAndQuoteInput
  }

  type Review {
    audio: ScoreAndQuote
    author: Author
    editions: [String]
    extra: ScoreAndQuote
    id: ID!
    images: CriticImages
    movie: ScoreAndQuote
    releaseDate: String
    total: ScoreAndQuote
    url: String!
    video: ScoreAndQuote
  }

  input ReviewOverridesInput {
    audio: ScoreAndQuoteInput
    extra: ScoreAndQuoteInput
    movie: ScoreAndQuoteInput
    releaseDate: String
    total: ScoreAndQuoteInput
    video: ScoreAndQuoteInput
  }

  type ReviewResponse {
    id: ID!
    serviceName: String!
  }

  input PreviewAddInput {
    isUHD: Boolean!
    serviceName: String!
    url: String!
  }

  type Preview {
    audio: ScoreAndQuote
    author: Author
    editions: [String]
    extra: ScoreAndQuote
    errorFields: [String]
    images: CriticImages
    isValid: Boolean!
    movie: ScoreAndQuote
    releaseDate: String
    serviceName: String!
    techSpecs: [[String]]
    total: ScoreAndQuote
    url: String!
    video: ScoreAndQuote
  }

  type PreviewValidateResponse {
    errorFields: [String]
    isValid: Boolean!
    serviceName: String!
  }

  type ScoreAndQuote {
    quote: String
    score: Float
    section: String
  }

  input ScoreAndQuoteInput {
    quote: String
    score: Float
    section: String
  }
`

export default critics
